import { Component, OnInit, ViewChild, HostListener, Renderer2, OnDestroy, } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { KButtonType, KKcgButtonSubType } from 'ng-k-button';
import { GlobalLoadingService } from 'src/app/services/global-loading.service';
import { NihlOutlineExposureService } from 'src/app/services/nihl-outline-exposure.service';
import { NihlComparisonService } from 'src/app/services/nihl-comparison.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ColorFactory, Side } from './color-factory';
import { AudiogramComparisonPageLeaveDataService } from 'src/app/services/audiogram-comparison-page-leave-data.service';
import { ClaimsService } from 'src/app/services/claims.service';

interface AudioData {
  id: string;
  title: string;
  form_data: FormData | null;
}

@Component({
  selector: 'app-audiogram-compare',
  templateUrl: './audiogram-compare.component.html',
  styleUrls: ['./audiogram-compare.component.scss']
})
export class AudiogramCompareComponent implements OnInit {
  KButtonType = KButtonType;
  KKcgButtonSubType = KKcgButtonSubType;
  public claimId = '';
  public taskId = '';
  public createAudiometryTaskId = '';
  @ViewChild('stickySaveBar') stickySaveBar: any;
  // Form
  public searchAudiogramFilterForm: any;
  public allAudioData: AudioData[] = [];
  public filter: any = {};
  public allAudiometryTests = [];
  public audiogramIds: any[] = [];
  public audiogramComparisonVals: { ids: String[], values: Boolean[], colors: String[] } = { ids: [], values: [], colors: [] };
  linesRight: any = [];
  linesLeft: any = [];
  linesRightAvg: any = [];
  linesLeftAvg: any = [];
  chartType = '';
  // Keep the checkbox enabled by default
  isAvgChecked: boolean = false;
  isCompChecked: boolean = false;
  rightAvgCompData: any = null;
  leftAvgCompData: any = null;

  public chartLabelsForArhlRight: any[] = [];
  public arhlChartColorsR: any[] = [];
  public chartLabelsForArhlLeft: any[] = [];
  public arhlChartColorsL: any[] = [];
  public color1 = '#ABABAB';
  public color2 = '#0000FF';

  public errorText!: string;
  public successText!: string;
  public displayError: boolean = false;
  public displaySuccess: boolean = false;
  public timeout!: number;

  public confirmSaveNewAudiometryModalReference: any;
  closeResult = '';

  tinnitusConditionsList: string[] = ['Not Declared', 'None', 'Slight', 'Mild', 'Moderate', 'Severe', 'Catastrophic'];
  tinnitusCondition: string = 'Not Declared';

  public saveAudiogramComparisonDataStatus = 'uptodate';

  public customData: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private loaderService: GlobalLoadingService,
    private nihlOutlineExposureService: NihlOutlineExposureService,
    private nihlComparisonService: NihlComparisonService,
    private modalService: NgbModal,
    private renderer: Renderer2,
    private colorFactory: ColorFactory,
    private audiogramComparisonPageLeaveDataService: AudiogramComparisonPageLeaveDataService,
    private claimsService: ClaimsService
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.claimId = decodeURIComponent(params['claimId']);
      this.taskId = decodeURIComponent(params['taskId']);
      this.createAudiometryTaskId = decodeURIComponent(params['createAudiometryTaskId']);
      this.colorFactory.init(this.claimId, this.taskId)
    });

    this.searchAudiogramFilterFormValidation();
    this.getAllAudiometryTestList(null);
    this.setValueInService(this.saveAudiogramComparisonDataStatus, 'audiogram-compare');
    this.getWorkflowOverview(this.claimId);
  }

  public getWorkflowOverview(claimID: any) {
    const thisObj = this;
    const requestParam: any = {};
    requestParam.claimId = claimID ? claimID : null;
    this.loaderService.startLoadingIndicator('getWorkflowOverview');

    thisObj.claimsService.getWorkflowOverview(requestParam).subscribe(result => {
      if (result.status === 'Success') {
        this.loaderService.stopLoadingIndicator('getWorkflowOverview');

        this.customData = {
          claimId : this.claimId,
          taskId: this.taskId,
          claimantName : result.data.meta.claimant.claimantName,
          medicalConditionLabel: 'NIHL',
          medicalConditionValue: 'nihl'
        };
      }
    },
      err => {
        console.log(err.error);
      });
  }

  public searchAudiogramFilterFormValidation() {
    this.searchAudiogramFilterForm = this.fb.group({
      keyword: '',
    });
  }

  public tinnitusOnChange($event: any) {
    this.tinnitusCondition = $event.target.value;
  }

  public getAllAudiometryTestList(keyword: any) {
    this.loaderService.startLoadingIndicator('getAllAudiometryTestList');
    const thisObj = this;
    const requestParam: any = {};
    requestParam.claimId = this.claimId ? this.claimId : null;
    requestParam.taskId = this.createAudiometryTaskId ? this.createAudiometryTaskId : null;
    requestParam.actionName = 'audiometry_view_all';
    requestParam.payload = {
      'search': keyword ? keyword : '',
      'composite_average': false
    };

    thisObj.nihlOutlineExposureService.getAllAudiometryTestList(requestParam).subscribe(result => {
      if (result.status === 'Success') {
        this.audiogramIds = [];
        this.audiogramComparisonVals = { ids: [], values: [], colors: [] };
        thisObj.allAudiometryTests = [];
        this.loaderService.stopLoadingIndicator('getAllAudiometryTestList');
        thisObj.allAudiometryTests = result.data;
        if (thisObj.allAudiometryTests.length > 0) {
          thisObj.allAudiometryTests.forEach((data: any, index: number) => {
            if (data?.compared) {
              this.audiogramIds.push(data._id);
              this.audiogramComparisonVals.ids.push(data._id);
              this.audiogramComparisonVals.values.push(true);
              this.audiogramComparisonVals.colors.push(data?.lineColor || this.setColor());
            }
            // if (index == 0 ) {
            //   this.audiogramIds.push(data._id);
            //   this.getChartData(this.claimId, this.audiogramIds);
            // }
          });

          if (this.audiogramIds.length < 1) {
            setTimeout(() => {
              let ele = document.getElementById(thisObj.allAudiometryTests[0]['_id']);
              ele?.click();
            }, 0);
          }
          this.getChartData(this.claimId, this.audiogramIds);

          const element = <HTMLElement>document.getElementsByClassName('avgCompToggle')[0];
          element.style.display = 'block';
        } else {
          const element = <HTMLElement>document.getElementsByClassName('avgCompToggle')[0];
          element.style.display = 'none';
        }

      }
    }, err => {
    });
  }

  async goToPage() {
    this.router.navigate(['/claimDetail/', this.claimId]);
  }

  submit_searchAudiogramFilterForm($event: any, form: any) {
    const thisObj = this;
    if (form.status === 'VALID') {
      this.filter.searchKeyword = form.value.keyword;
      this.saveAudiogramComparisonDataStatus = "filtered";
      this.getAllAudiometryTestList(this.filter.searchKeyword)
      const element = <HTMLElement>document.getElementsByClassName('avgCompDataWrap')[0];
      element.style.display = 'none';
      const getCheckbox = document.getElementById(this.chartType) as HTMLInputElement | null;
      if (getCheckbox != null) {
        getCheckbox.checked = false;
      }
      $event.preventDefault();
    }
  }

  reset_searchAudiogramFilterForm(form: any) {
    const thisObj = this;
    if (form.status === 'VALID') {
      form.reset();
      this.filter.searchKeyword = '';
      this.saveAudiogramComparisonDataStatus = "uptodate";
      thisObj.getAllAudiometryTestList(this.filter.searchKeyword);
      const element = <HTMLElement>document.getElementsByClassName('avgCompDataWrap')[0];
      element.style.display = 'none';
      const getCheckbox = document.getElementById(this.chartType) as HTMLInputElement | null;
      if (getCheckbox != null) {
        getCheckbox.checked = false;
      }
    }
  }

  modifierUpdated(initiation?: Boolean) {
    if (this.saveAudiogramComparisonDataStatus != 'filtered') {
      this.saveAudiogramComparisonDataStatus = initiation ? 'uptodate' : 'modified';
    }
    this.setValueInService(this.saveAudiogramComparisonDataStatus, 'audiogram-compare');
    this.setSaveAudiogramComparisonParamsInService();

    if (initiation) {
      this.audiogramComparisonPageLeaveDataService.saveParams().toPromise();
    }
  }

  //check audiogram has selected for Comparison
  checkedAudiogram(data: any, index: number) {
    return data?.compared || false;
  }

  setValueInService(value: any, currentPage: any): void {
    const currPage = currentPage;
    this.audiogramComparisonPageLeaveDataService.setValue(value, currPage);
  }

  setSaveAudiogramComparisonParamsInService() {
    const requestParam: any = {};
    requestParam.claimId = this.claimId;
    requestParam.testIds = this.audiogramComparisonVals.ids;
    requestParam.values = this.audiogramComparisonVals.values;
    requestParam.colors = this.audiogramComparisonVals.colors;
    this.audiogramComparisonPageLeaveDataService.sendParams(requestParam);
  }

  selectAudiogram(selectedAudiogram: any, event: any, initiation?: boolean) {
    const element = <HTMLElement>document.getElementsByClassName('avgCompDataWrap')[0];
    if (event.target['checked'] == true) {
      if (this.saveAudiogramComparisonDataStatus != "filtered") {
        initiation = this.audiogramIds.length == 0 ? true : false;
      }
      this.audiogramIds.push(selectedAudiogram._id);

      const index = this.audiogramComparisonVals?.ids.indexOf(selectedAudiogram._id);
      if (index === -1) {
        //add item
        this.audiogramComparisonVals.ids.push(selectedAudiogram._id);
        this.audiogramComparisonVals.values.push(true);
        this.audiogramComparisonVals.colors.push(selectedAudiogram?.lineColor || this.setColor());
      }
      else {
        //modify item
        this.audiogramComparisonVals.values[index] = true;
        this.audiogramComparisonVals.colors[index] = selectedAudiogram?.lineColor || this.setColor();
      }

      this.getChartData(this.claimId, this.audiogramIds);
      if (element && element.style.display == 'block') {
        this.selectAverageOrComposite(this.chartType, null, true);
      }
    } else {
      const index = this.audiogramIds.indexOf(selectedAudiogram._id);
      if (this.audiogramIds.length == 1) {
        event.preventDefault();
        this.errorText = 'Cannot uncheck the audiogram as it requires atleast 1 audiogram to view the graph';
        this.showMessage('error', 2000);
        setTimeout(() => {
          this.displayError = false;
        }, 2001);
        return;
      }
      if (index !== -1) {
        this.audiogramIds.splice(index, 1);

        const acIndex = this.audiogramComparisonVals?.ids.indexOf(selectedAudiogram._id);
        if (acIndex !== -1) {
          //modify item
          this.audiogramComparisonVals.values[index] = false;
          this.audiogramComparisonVals.colors[index] = "";
        }

        this.getChartData(this.claimId, this.audiogramIds);

        if (this.audiogramIds.length <= 1 && element.style.display == 'block') {
          this.errorText = 'Need atleast 2 audiograms to view Averaged or Composite chart';
          this.showMessage('error', 2000);
          setTimeout(() => {
            this.displayError = false;
          }, 2001);
          element.style.display = 'none';
          console.log(this.chartType);
          const getCheckbox = document.getElementById(this.chartType) as HTMLInputElement | null;
          if (getCheckbox != null) {
            getCheckbox.checked = false;
          }
        } else {
          if (element.style.display == 'block') {
            this.selectAverageOrComposite(this.chartType, null, true);
          }
        }

      }
    }
    if (initiation)
      this.modifierUpdated(true);
    else
      this.modifierUpdated();
  }

  public getChartData(claimId: any, audiogramIds: any) {
    this.loaderService.startLoadingIndicator('getChartData');
    const thisObj = this;
    const requestParam: any = {};
    requestParam.claimId = claimId ? claimId : null;
    requestParam.testIds = audiogramIds;

    thisObj.nihlComparisonService.compareAudiogram(requestParam).subscribe(result => {
      if (result.status === 'Success') {
        this.loaderService.stopLoadingIndicator('getChartData');
        this.reshapeData(result.data.right, 'right');
        this.reshapeData(result.data.left, 'left');
      }
    }, err => {
    });
  }

  public getAvgCompositeData(chartType: any, claimId: any, audiogramIds: any) {
    this.loaderService.startLoadingIndicator('getAvgCompositeData');
    const thisObj = this;
    const requestParam: any = {};
    // console.log(requestParam)
    requestParam.claimId = claimId ? claimId : null;
    requestParam.testIds = audiogramIds;
    // console.log(chartType)
    requestParam.type = chartType;
    // console.log(requestParam)
    thisObj.nihlComparisonService.getAvgCompositeData(requestParam).subscribe(result => {
      if (result.status === 'Success') {
        this.loaderService.stopLoadingIndicator('getAvgCompositeData');
        this.reshapeAvgCompDataSet(result.data.right, 'right');
        this.reshapeAvgCompDataSet(result.data.left, 'left');
        if (result.data.right) {
          this.rightAvgCompData = result.data.right;
        }
        if (result.data.left) {
          this.leftAvgCompData = result.data.left;
        }
      }
    }, err => {
      console.log(err);
      this.loaderService.stopLoadingIndicator('getAvgCompositeData');
      this.errorText = err.error.data;
      const element = <HTMLElement>document.getElementsByClassName('avgCompDataWrap')[0];
      element.style.display = 'none';

      this.showMessage('error', 2000);
      setTimeout(() => {
        this.displayError = false;
      }, 2001);
      this.isAvgChecked = false;
      this.isCompChecked = false;
      const getCheckbox = document.getElementById(chartType) as HTMLInputElement | null;
      if (getCheckbox != null) {
        getCheckbox.checked = false;
      }
    });
  }

  public reshapeData(data: any, earSide: any) {
    for (let [index, value] of data.data.entries())
      if (earSide == 'right') {
        let lineitemsR = [];
        this.arhlChartColorsR = [];
        this.chartLabelsForArhlRight = [];
        for (let [index, value] of data.data.entries()) {
          let _id = data.ids[index];
          // let colorR = this.colorFactory.getColor(_id, 'r', index);

          const idIndex = this.audiogramComparisonVals.ids.findIndex(id => id === _id);
          let colorR = this.audiogramComparisonVals.colors[idIndex] || "";

          if (colorR == "") {
            colorR = this.colorFactory.getColor(_id, 'r', index);
            colorR = this.colorFactory.rgba2hex(colorR, true);
            this.audiogramComparisonVals.colors[idIndex] = colorR;
            this.setSaveAudiogramComparisonParamsInService();
          }
          // if (index % 2 === 0 ) {
          //   this.arhlChartColorsR.push({backgroundColor: 'rgba(171,171,171,0.3)', borderColor: 'rgba(171,171,171,0.3)'});
          //   colorR = this.color1;
          // } else {
          //   this.arhlChartColorsR.push({backgroundColor: 'rgba(0,0,255,0.3)', borderColor: 'rgba(0,0,255,0.3)'});
          //   colorR = this.color2;
          // }
          this.arhlChartColorsL.push({ backgroundColor: colorR, borderColor: colorR });
          this.chartLabelsForArhlRight.push({ id: index, title: data.dataLabel[index], color: colorR, _id });
          lineitemsR.push({
            profile: earSide,
            label: data.dataLabel[index],
            data: value,
            attribute: {
              color: colorR,
              borderColor: colorR
            }
          });
        }
        this.linesRight = lineitemsR;
      } else {
        let lineitemsL = [];
        this.arhlChartColorsL = [];
        this.chartLabelsForArhlLeft = [];
        for (let [index, value] of data.data.entries()) {
          let _id = data.ids[index];
          // let colorL = this.colorFactory.getColor(_id, 'l', index);

          const idIndex = this.audiogramComparisonVals.ids.findIndex(id => id === _id);
          let colorL = this.audiogramComparisonVals.colors[idIndex] || "";

          if (colorL == "") {
            colorL = this.colorFactory.getColor(_id, 'l', index);
            colorL = this.colorFactory.rgba2hex(colorL, true);
          }
          this.arhlChartColorsL.push({ backgroundColor: colorL, borderColor: colorL });
          // if (index % 2 === 0 ) {
          //   this.arhlChartColorsL.push({backgroundColor: 'rgba(171,171,171,0.3)', borderColor: 'rgba(171,171,171,0.3)'});
          //   colorL = this.color1;
          // } else {
          //   this.arhlChartColorsL.push({backgroundColor: 'rgba(0,0,255,0.3)', borderColor: 'rgba(0,0,255,0.3)'});
          //   colorL = this.color2;
          // }
          this.chartLabelsForArhlLeft.push({ id: index, title: data.dataLabel[index], color: colorL, _id });
          // console.log(this.chartLabelsForArhlLeft)
          lineitemsL.push({
            profile: earSide,
            label: data.dataLabel[index],
            data: value,
            attribute: {
              color: colorL,
              borderColor: colorL
            }
          });
        }
        this.linesLeft = lineitemsL;
      }
  }

  getHexToRgb(hex: any) {
    const [r, g, b] = hex.match(/\w\w/g).map((x: any) => parseInt(x, 16));
    return {
      r,
      g,
      b,
    };
  }
  legendOnClick() {
    return (ev: any, p1: any, p2: any) => {
    }
  }

  changeColor(event: any, id: any, graphType: any, _id: any) {
    const { r, g, b } = this.getHexToRgb(event.target.value);
    let color = `rgb(${r},${g},${b})`;
    let side: Side = graphType == 'arhlL' ? 'l' : 'r';
    this.colorFactory.setCache(_id, side, color);
    //this.arhlChartColorsL[id].backgroundColor = `rgba(${r},${g},${b},0.3)`;
    //this.arhlChartColorsL[id].borderColor = `rgba(${r},${g},${b},0.3)`;
    this.linesLeft[id].attribute = { color };
    this.linesLeft = [...this.linesLeft];
    //this.arhlChartColorsR[id].backgroundColor = `rgba(${r},${g},${b},0.3)`;
    //this.arhlChartColorsR[id].borderColor = `rgba(${r},${g},${b},0.3)`;
    this.linesRight[id].attribute = { color };
    this.linesRight = [...this.linesRight];
    const idIndex = this.audiogramComparisonVals.ids.findIndex(id => id == _id);
    if (side == 'r') {
      this.audiogramComparisonVals.colors[idIndex] = this.colorFactory.rgba2hex(color, true);
    }
    this.modifierUpdated();
  }

  public reshapeAvgCompDataSet(data: any, earSide: any) {
    let lineitems = [];
    lineitems.push({
      profile: earSide,
      label: data?.chart?.arhl?.dataLabel[0],
      data: data?.chart?.arhl?.data[0]
    });
    if (earSide == 'right') {
      this.linesRightAvg = lineitems;
    } else {
      this.linesLeftAvg = lineitems;
    }
  }

  public selectAverageOrComposite(chartType: any, $event?: any, isTrue?: any) {
    const element = <HTMLElement>document.getElementsByClassName('avgCompDataWrap')[0];
    this.getAvgCompositeData(chartType, this.claimId, this.audiogramIds);
    if (chartType == 'composite') {
      const avgCheckbox = document.getElementById('average',) as HTMLInputElement | null;
      if (avgCheckbox != null) {
        avgCheckbox.checked = false;
      }
    }
    else {
      const compCheckbox = document.getElementById('composite',) as HTMLInputElement | null;
      if (compCheckbox != null) {
        compCheckbox.checked = false;
      }
    }

    if (this.audiogramIds.length > 1 && isTrue) {
      this.chartType = chartType;
      element.style.display = 'block';
    } else
      if (this.audiogramIds.length > 1 && ($event.target['checked'] == true)) {
        this.chartType = chartType;
        element.style.display = 'block';
      } else {
        element.style.display = 'none';
      }
  }

  public showMessage(msgType: any, timeout: any) {
    if (msgType === 'error') {
      this.displayError = true;
    }
    if (msgType === 'success') {
      this.displaySuccess = true;
    }
    if (timeout) {
      this.timeout = timeout;
    }
  }

  public submit_saveAsNewAudiometry(audiogramIds: any, rightAvgCompData: any, leftAvgCompData: any, chartTypeSelected: any) {
    this.loaderService.startLoadingIndicator('submit_saveAsNewAudiometry');
    const thisObj = this;
    const requestParam: any = {};
    requestParam.claimId = this.claimId ? this.claimId : null;
    requestParam.testIds = audiogramIds;
    requestParam.audiometryType = chartTypeSelected;
    requestParam.tinnitus = this.tinnitusCondition;

    thisObj.nihlComparisonService.saveAsNewAudiometry(requestParam).subscribe(result => {
      if (result.status === 'Success') {
        this.loaderService.stopLoadingIndicator('submit_saveAsNewAudiometry');
        this.successText = this.chartType.toUpperCase() + ' saved successfully'
        this.showMessage('success', 2000);
      }
    }, err => {
    });

    this.modalService.dismissAll();
    setTimeout(() => {
      this.router.navigate(['/claimDetail/', this.claimId, 'medical']);
    }, 2002);
    // this.getDismissReason('save')
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      // console.log(reason)
      return `with: ${reason}`;
    }
  }

  public closeConfirmSaveNewAudiometry() {

  }

  public open(content: any) {
    this.confirmSaveNewAudiometryModalReference = this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'sm', centered: true, windowClass: ' audiometryResult_mdl' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
      // console.log(this.closeResult)
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      // console.log(this.closeResult)
    });
  }

  public cancel_saveAsNewAudiometry() {

  }


  setColor = () => {
    let color = '';
    color = this.colorFactory.getColor('', 'r', 0);
    color = this.colorFactory.rgba2hex(color, true);
    return color;
  }


  @HostListener('window:scroll', ['$event'])
  windowScroll(event: any) {

    const stickyElemOffsetTop = this.stickySaveBar.nativeElement.offsetTop;
    const pageYOffest = window.pageYOffset
    const stickyClassName = 'sticky_box_space';
    //console.log(pageYOffest,stickyElemOffsetTop);
    if (pageYOffest >= (stickyElemOffsetTop - 76)) {
      this.renderer.addClass(this.stickySaveBar.nativeElement, stickyClassName);
    } else {
      this.renderer.removeClass(this.stickySaveBar.nativeElement, stickyClassName);
    }
  }

}
